module.exports = __webpack_public_path__ + "assets/img/index4.31e670a9.jpg";